export const getOS = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod|mac/.test(userAgent)) {
    return 'ios'
  }
  if (/webOS/i.test(navigator.userAgent)) {
    return 'android'
  }
  return 'other'
}
